import type { LocalizedDict } from '../index'
import type {
  ResourceCategory,
  ResourceType,
  ResourceVisibility,
} from '../../mocks/data/resources'

export type ResourcesLibraryStrings = {
  title: string
  subtitle: string
  visibleToAll: string
  roleFiltered: string
  filter: string
  all: (n: number) => string
  typeCount: (label: string, n: number) => string
  loading: string
  noResourcesForFilter: string
  externalSuffix: string
  noContent: string
  published: string
  updated: string
  loadError: string
  noResources: string
  externalLink: string
  document: string
  types: Record<ResourceType, string>
  categories: Record<ResourceCategory, string>
  visibility: Record<ResourceVisibility, string>
}

export const resourcesLibraryI18n: LocalizedDict<ResourcesLibraryStrings> = {
  en: {
    title: 'Resources Library',
    subtitle: 'PEXIFY admin-curated guides, policies, templates · D-6 ADMIN-owned ·',
    visibleToAll: ' Visible to all roles',
    roleFiltered: ' Role-specific filtering active',
    filter: 'Filter:',
    all: (n) => `All (${n})`,
    typeCount: (label, n) => `${label} (${n})`,
    loading: 'Loading…',
    noResourcesForFilter: 'No resources for this filter.',
    externalSuffix: ' is an external link or template.',
    noContent: 'No content available.',
    published: 'Published: ',
    updated: 'Updated: ',
    loadError: "Couldn't load resources.",
    noResources: 'No resources yet.',
    externalLink: 'External Link',
    document: 'Document',
    types: { guide: 'Guide', policy: 'Policy', template: 'Template', link: 'External Link' },
    categories: {
      getting_started: 'Getting started',
      operations: 'Operations',
      production: 'Production',
      pricing: 'Pricing',
      compliance: 'Compliance',
      branding: 'Branding',
    },
    visibility: {
      all: 'All roles',
      seller_only: 'Seller only',
      supply_only: 'Supply only',
      b2b_only: 'B2B only',
    },
  },
  tr: {
    title: 'Kaynak Kütüphanesi',
    subtitle: 'PEXIFY yöneticisinin derlediği rehberler, politikalar, şablonlar · D-6 ADMIN sahipli ·',
    visibleToAll: ' Tüm rollere görünür',
    roleFiltered: ' Role göre filtreleme açık',
    filter: 'Filtre:',
    all: (n) => `Tümü (${n})`,
    typeCount: (label, n) => `${label} (${n})`,
    loading: 'Yükleniyor…',
    noResourcesForFilter: 'Bu filtrede kaynak yok.',
    externalSuffix: ' bir dış bağlantı ya da şablondur.',
    noContent: 'İçerik yok.',
    published: 'Yayın: ',
    updated: 'Güncelleme: ',
    loadError: 'Kaynaklar yüklenemedi.',
    noResources: 'Henüz kaynak yok.',
    externalLink: 'Dış bağlantı',
    document: 'Doküman',
    types: { guide: 'Rehber', policy: 'Politika', template: 'Şablon', link: 'Dış Link' },
    categories: {
      getting_started: 'Başlangıç',
      operations: 'Operasyon',
      production: 'Üretim',
      pricing: 'Fiyatlandırma',
      compliance: 'Uyum',
      branding: 'Marka',
    },
    visibility: {
      all: 'Tüm Roller',
      seller_only: 'Sadece Satıcı',
      supply_only: 'Sadece Üretim',
      b2b_only: 'Sadece B2B',
    },
  },
}
